export default __webpack_public_path__ + "static/ASW-GB-Bilderstoeckchen-fd0a5ef737751180d4c7a0a1f5fa73f1.mp4";